var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtomsIconFilledTutor2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.962 22.8c-.208-.61-.527-1.461-.75-2.232l-1.962-.5a.479.479 0 0 1-.342-.58.472.472 0 0 1 .572-.348l2.022.515c.538.098 2.011.695 2.953.017.712-.512.996-3.004 1.085-4.048.302-.056 1.028-.241 1.184-.764.199-.665-.92-.955-1.368-2.96-.058-.254-.102-.53-.141-.805a6.477 6.477 0 0 0-.14-.923c.003-.018.013-.034.013-.052V8.012L13.24 9.886a.571.571 0 0 1-.74-.336.586.586 0 0 1 .332-.752l8.54-3.302a.383.383 0 0 0-.016-.71l-9.22-3.561a.378.378 0 0 0-.27 0L2.644 4.787a.384.384 0 0 0-.244.36c0 .158.097.302.244.358l.634.245v2.633A1.276 1.276 0 0 0 2.4 9.599c0 .702.563 1.274 1.256 1.274.694 0 1.258-.572 1.258-1.274 0-.57-.37-1.053-.879-1.216v-2.34l1.879.725v3.352c0 .016.008.032.01.049a6.357 6.357 0 0 0 1.164 5.287h-.002l.022.026c.034.043.066.085.1.126.185.248.52.776.59 1.426.088.8-.52 4.834-.623 5.766h7.787z",
    fill: "#F60",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomsIconFilledTutor2);
export default __webpack_public_path__ + "static/media/atoms-icon-filled-tutor-2.a103fbb4c5d5261ef8559c4aef5c28c8.svg";
export { ForwardRef as ReactComponent };